module.exports = __webpack_public_path__ + "img/02.bd171ab8.jpg";